import React from 'react';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();

  const user = useUser();

  const navigation = useSetupNavigation(Urls.HOPE);

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Hope</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.EXPERIENCE)}
        onNext={(newData) => history.push(Urls.DEMOGRAPHICS)}
        onSkip={() => history.push(Urls.DEMOGRAPHICS)}
      />
    </ParentLayout>
  );
};
